// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ylczN","block":"Footer_block__d6iUh","info":"Footer_info__Fmp35"};